const Report = () => import('./Report.vue')

const Expense = () => import('./pages/Expense.vue')
const Revenue = () => import('./pages/Revenue.vue')
const Yield = () => import('./pages/Yield.vue')

const routes = {
  component: Report,
  path: '/relatorios',
  meta: {
    label: 'Relatórios'
  },
  children: [
    {
      path: 'despesas',
      component: Expense,
      name: 'expenseReport',
      meta: {
        label: 'Despesas',
        requiredPermission: {resource: 'expense', value: 'view'}
      }
    },
    {
      path: 'faturamentos',
      component: Revenue,
      name: 'revenueReport',
      meta: {
        label: 'Faturamento',
        requiredPermission: {resource: 'revenue', value: 'view'}
      }
    },
    {
      path: 'recebimentos',
      component: Yield,
      name: 'yieldReport',
      meta: {
        label: 'Recebimento',
        requiredPermission: {resource: 'yield', value: 'view'}
      }
    }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/pages/reports/routes.js